import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Card, Button, Modal, Col, Row } from 'react-bootstrap';
import { Redirect, Link } from 'react-router-dom';
//import { CardElement, Elements, useStripe, useElements } from '@stripe/react-stripe-js';
import { getJob, verifyOtp, verifyOtpAsync, sendOtp, sendOtpAsync, createAccount, createJob, setToken, setProfile, parseJob, preparePhone, getTypeTextGlobal } from '../../redux/Actions';
import PhoneInput from 'react-phone-input-2';
import OTPInput from 'otp-input-react';
import Loader from 'react-loader-spinner';
import StripeCheckout from 'react-stripe-checkout';
import { store } from 'react-notifications-component';
import { socket } from '../../socket/socketio';
import { trackEvent } from '../../utils/analytics';
import './Payment.css';
import 'react-phone-input-2/lib/style.css';

class Payment extends Component {

    constructor(props) {
        super(props)
        this.state = {
            body_class: ['apps-gotlocked-order'],
            redirect: false,
            showModal: false,
            otp_status: false,
            phonenumber: '',
            otpContent: '',
            modalButtonText: '',
            otp: '',

            job: null,

            loader: true,
            goback: false,
            gomap: false,
            hide_again: false,
            verify_counter: 0
        }
    }

    componentWillMount() {
        document.body.classList.add(...this.state.body_class);
        this.props.getJob();
    }

    componentDidMount() {
        if (typeof this.props.job !== "undefined") {
            this.setState({
                loader: false
            });
        }
        //letcheck if we have job in storage
        setTimeout(function () {
            if (this.state.job === null) {
                this.setState({
                    goback: true
                });
            }
            if (this.props.active_job !== undefined && this.props.active_job !== null) {
                this.setState({
                    redirect: true
                });
            }
        }.bind(this), 3500);
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            if (typeof this.props.job === "undefined" || this.props.job === null) {
                this.setState({
                    goback: true
                });
            }
            this.setState({
                loader: false
            });
        }
        if (typeof this.props.job === "undefined" || this.props.job === null) {
            this.setState({
                goback: true
            });
        }
        if (this.state.job === null && this.state.job !== this.props.job) {
            this.setState({
                job: this.props.job
            });
        }
    }

    hideModal() {
        this.setState({ showModal: false });
    }

    sendOtpCodeAgain() {
        this.setState({
            hide_again: true
        });
        this.sendOtpCode();
    }

    async sendOtpCode() {
        this.props.setToken('');
        let resp = await sendOtpAsync(preparePhone(this.state.phonenumber));
        if (resp.error_code) {
            switch (resp.error_code) {
                case "28ca4":
                    this.props.createAccount({
                        phonenumber: preparePhone(this.state.phonenumber),
                        firstname: this.state.job.address.firstname,
                        lastname: this.state.job.address.lastname
                    });
                    break;
                default:
                    store.addNotification({
                        title: 'General error occured ' + resp.error_code,
                        message: resp.msg,
                        type: 'danger',
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });
                    break;
            }
        }
    }

    async verifyOtp() {
        if (this.state.otp) {
            this.setState({
                loader: true
            });
            //let otp_status = this.props.verifyOtp(this.state.phonenumber.replace(/\s/g, ''), this.state.otp);
            let otp_status = await verifyOtpAsync(preparePhone(this.state.phonenumber), this.state.otp);
            if (otp_status.error_code) {
                store.addNotification({
                    title: 'General error occured ' + otp_status.error_code,
                    message: otp_status.msg,
                    type: 'danger',
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
                this.setState({
                    loader: false
                });
                return;
            }
            socket.emit('customer', { customerid: otp_status.user.customerid, phonenumber: otp_status.user.phonenumber });
            this.props.setToken(otp_status.token);
            this.props.setProfile(otp_status.user);
            this.setState({
                loader: true
            })
            setTimeout(function () {
                trackEvent('generate_lead', {
                    method: 'otp',
                    job_type: this.state.job ? this.state.job.job_type : 'unknown',
                });
                this.props.createJob(parseJob(preparePhone(this.state.phonenumber), this.state.job));
                this.setState({
                    redirect: true
                });
            }.bind(this), 3000);
        }
    }

    gotoMap() {
        this.setState({
            gomap: true
        });
    }

    gotoStatus() {
        if (this.state.token) {
            this.props.createJob(parseJob(preparePhone(this.state.phonenumber), this.state.job));
            setTimeout(function () {
                if (this.props.active_job === null || this.props.active_job === "") {
                    this.setState({
                        redirect: true
                    });
                }
            }.bind(this), 3000);
        } else {
            // if (this.state.job.payment_method === "credit_card") {
            //     this.inputElement.showStripeDialog();
            // } else {
            //     this.otpDialog();
            // }
            this.otpDialog();
        }
    }

    otpDialog() {
        if (this.state.phonenumber === '') {
            this.setState({
                showModal: true,
                modalButtonText: 'Get One Time Password'
            });
        } else if (this.state.otp_status === false && this.state.phonenumber !== '') {
            this.sendOtpCode();
            this.setState({
                showModal: true,
                otp_status: true,
                modalButtonText: 'Create Job Request'
            });
        } else {
            if (this.state.otp === '' || this.state.verify_counter >= 2) {
                this.setState({
                    showModal: true,
                    otp_status: true,
                    modalButtonText: 'Create Job Request',
                    verify_counter: 0
                });
            } else {
                this.setState({
                    loader: true,
                    verify_counter: this.state.verify_counter + 1
                });
                this.verifyOtp();
            }
        }
    }

    setOtp(otp) {
        this.setState({
            otp: otp
        });
    }

    getTypeText() {
        let text = 'House Lockout';
        if (this.state.job !== null) {
            text = getTypeTextGlobal(this.state.job.job_type);
        }
        return text;
    }

    getCardImage() {
        if (this.state.job.image) {
            return <Card.Img variant="top" src={this.state.job.image} />;
        }
        return <Card.Img variant="top" src="data:image/png;base64,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" />
    }

    onPaymentToken(token) {
        this.setState(prevState => ({
            job: {
                ...prevState.job,
                payment_data: token
            }
        }));
        this.otpDialog();
    }

    changePaymentType(type) {
        this.setState(prevState => ({
            job: {
                ...prevState.job,
                payment_method: type
            }
        }));
    }

    render() {
        if (this.state.redirect) {
            return (<Redirect push to='/status' />);
        }
        if (this.state.goback) {
            return (<Redirect push to='/order' />);
        }
        if (this.state.gomap) {
            return (<Redirect push to='/map' />);
        }
        let otpContent = '';
        if (this.state.otp_status) {
            if (this.state.hide_again) {
                otpContent = <div>
                    <OTPInput className="otpinput"
                        inputStyles={{ marginRight: '10px' }}
                        value={this.state.otp}
                        onChange={otp => this.setOtp(otp)}
                        autoFocus
                        OTPLength={5} otpType="number" disabled={false} />
                </div>;
            } else {
                otpContent = <div>
                    <OTPInput className="otpinput"
                        inputStyles={{ marginRight: '10px' }}
                        value={this.state.otp}
                        onChange={otp => this.setOtp(otp)}
                        autoFocus
                        OTPLength={5} otpType="number" disabled={false} />
                    <div className="text-center"><Link to="#" onClick={() => this.sendOtpCodeAgain()}>send code again</Link></div>
                </div>;
            }
        }

        let job_card = this.state.job !== null ? <Card className="payment_job_details" style={{ width: '18rem' }}>
            {this.getCardImage()}
            <Card.Body>
                <Card.Title>{this.getTypeText()}</Card.Title>
                <Card.Text>
                    <span><strong>Job description: </strong><br />{this.state.job.description.split('\n').map((item, i) => <span key={i}>{item}<br /></span>)}<br /></span>
                    <br />
                    Address: {this.state.job.address.address}, {this.state.job.address.city}, {this.state.job.address.state} {this.state.job.address.zip}  <Button variant="link" onClick={() => this.gotoMap()} className="updatemap">update</Button><br />
                    Name: {this.state.job.address.name}
                </Card.Text>
            </Card.Body>
        </Card> : null;

        let stripe_checkout = StripeCheckout ? <StripeCheckout
            name={"Payment for " + this.getTypeText()}
            description="We capturing your payment to make sure with closing job"
            token={(token) => { this.onPaymentToken(token) }}
            stripeKey="pk_live_51IUVJ7DCoV9H6rHlxxMkhzWSDYrbmTHv3QCuFjTYj3OGhX1GLMYWUiY9L9KTU9lt56BlzmkdJ8O2Z1dXo9wCwzoM00dQpPrVck"
            ref={input => this.inputElement = input}
            allowRememberMe={false}
            className="payment_button"
        /> : null;

        return (
            <div>
                <Loader
                    type="Watch"
                    color="#fcae4b"
                    height={100}
                    width={100}
                    visible={this.state.loader}
                    className="loader"
                />
                <div className="apps-gotlocked-video-bg-section"></div>
                <section className="apps-gotlocked-order-section" id="apps-gotlocked-order">
                    <div className="apps-gotlocked-order-container">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 payment_page_form">
                                    <div className="apps-gotlocked-order-tbl-c">
                                        <div className="apps-gotlocked-order-content text-center">
                                            <h1>Job Request Overview</h1>
                                        </div>
                                    </div>
                                    <div className="apps-gotlocked-payment">
                                        <div className="row">
                                            <div className="col">
                                                {job_card}
                                                <br />

                                                <Card>
                                                    {/* <Card.Header>
                                                        <center>Please choose payment type:</center>
                                                        <Tab.Container defaultActiveKey="creditcard">
                                                            <div className="bg-white shadow-sm pt-4 pl-2 pr-2 pb-2">
                                                                <Nav variant="pills" fill="true" rounded="true" mb-3="true">
                                                                    <Nav.Item>
                                                                        <Nav.Link eventKey="creditcard" onClick={() => this.changePaymentType('credit_card')}><FontAwesomeIcon icon={faCreditCard} /> Credit Card</Nav.Link>
                                                                    </Nav.Item>
                                                                    <Nav.Item>
                                                                        <Nav.Link eventKey="cash" onClick={() => this.changePaymentType('cash')}><FontAwesomeIcon icon={faMoneyBill} /> Cash</Nav.Link>
                                                                    </Nav.Item>
                                                                </Nav>
                                                            </div>
                                                            <Tab.Content>
                                                                <Tab.Pane eventKey="creditcard">
                                                                    {stripe_checkout}
                                                                    <h6 className="text-center">Please note, you are not going to pay, until you accept job proposal and close final sum. </h6>
                                                                </Tab.Pane>
                                                                <Tab.Pane eventKey="cash">
                                                                    <br />
                                                                    <h6 className="text-center">Please note by paying cash, all the responsability is on tech </h6>
                                                                </Tab.Pane>
                                                            </Tab.Content>
                                                        </Tab.Container>
                                                    </Card.Header> */}
                                                    <Card.Footer>
                                                        <Button variant="success" onClick={() => this.gotoStatus()} className="shadow-sm btn-block subscribe">Create Job Request</Button>
                                                    </Card.Footer>
                                                </Card>
                                                <Modal show={this.state.showModal} aria-labelledby="contained-modal-title-vcenter" centered onHide={() => this.hideModal()}>
                                                    <Modal.Header closeButton>
                                                        <Modal.Title id="contained-modal-title-vcenter">
                                                            Phone confirmation
                                                        </Modal.Title>
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <Row className="phone_confirmation">
                                                            <Col xs={12} md={6}>
                                                                <PhoneInput prefix='' country={'us'} onlyCountries={['us', 'ca']} inputProps={{ required: true, autoFocus: true }} value={this.state.phonenumber} onChange={phone => this.setState({ phonenumber: phone })} />
                                                            </Col>
                                                            <Col xs={12} md={6}>
                                                                {otpContent}
                                                            </Col>
                                                        </Row>
                                                    </Modal.Body>
                                                    <Modal.Footer>
                                                        <Button variant="success" onClick={() => this.gotoStatus()}>{this.state.modalButtonText}</Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                        </div>
                                    </div>
                                    <br /><br />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div >
        );
    }
}

const mapStateToProps = (state) => {
    const { job, active_job, token } = state;
    return { job, active_job, token };
};

export default connect(mapStateToProps, { getJob, verifyOtp, sendOtp, createAccount, createJob, setToken, setProfile })(Payment);
// export default Payment;